import { render, staticRenderFns } from "./remote_charge.vue?vue&type=template&id=22badc44&scoped=true&"
import script from "./remote_charge.vue?vue&type=script&lang=js&"
export * from "./remote_charge.vue?vue&type=script&lang=js&"
import style0 from "./remote_charge.vue?vue&type=style&index=0&id=22badc44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22badc44",
  null
  
)

export default component.exports